import React from 'react';
import { useLocation } from 'react-router';
import { Link, Route, Switch, BrowserRouter as Router } from 'react-router-dom';
import Title from '../../../components/Title';
import '../../../index.css';
import closeIcon from '../../../icons/ic-close.png';
import faceIcon from '../../../icons/ic-face2.png';
import { ReactComponent as Inform } from '../../../icons/ic-information-tip.svg';

function ContentRegist({ history, closeModal }) {
  const location = useLocation();
  const [video, setVideo] = React.useState(location.state?.videoId ?? '');
  const [contentNo, setContentNo] = React.useState(
    location.state?.contentNo ?? null
  );

  const [state, setState] = React.useState({
    ContentTitle: '',
  });

  return (
    <Router>
      <Switch>
        <Route exact path="/" />
        <Route exact path="/v3" />
      </Switch>

      <div
        className="inner"
        style={{
          width: '90%',
          height: '95vh',
          margin: 'auto',
          padding: '20px 0',
          position: 'relative',
        }}
      >
        <div
          style={{
            display: 'block',
            flexDirection: 'row',
            alignItems: 'center',
            position: 'relative',
          }}
        >
          <Title title="콘텐츠 만들기" closeModal={closeModal} />
          <button
            className="close"
            style={{ position: 'absolute', top: 24, right: 0 }}
          >
            <img
              onClick={closeModal}
              style={{ cursor: 'pointer' }}
              src={closeIcon}
              alt="닫기 버튼"
            ></img>
          </button>
        </div>
        <div
          style={{
            width: '100%',
            borderRadius: 10,
            backgroundColor: 'white',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <div
            style={{
              display: 'flex',
              position: 'relative',
              flexDirection: 'row',
              alignItems: 'center',
              marginBottom: 85,
            }}
          ></div>
          <div style={{ margin: '0 auto' }}>
            {video ? (
              <iframe
                style={{ borderRadius: 10 }}
                width="845"
                height="474"
                src={'https://www.youtube.com/embed/' + video}
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            ) : (
              <div
                style={{
                  width: 845,
                  height: 474,
                  borderRadius: 10,
                  background: 'rgba(231, 231, 231, 0.45)',
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '2px solid #CCCCCC',
                }}
              >
                <div
                  style={{
                    width: 280,
                    height: 240,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                  }}
                >
                  <div>
                    <img src={faceIcon} />
                  </div>
                  <div style={{ marginTop: 10 }}>
                    <p style={{ color: '#848484', fontSize: 22 }}>
                      소개 할 영상을 넣어주세요.
                    </p>
                  </div>

                  <div style={{ marginTop: 10 }}>
                    <button
                      onClick={() => {
                        history.push({
                          pathname:
                            '/mypage/contents-making/contents-modal/video-list',
                          state: { ContentTitle: state.ContentTitle },
                        });
                      }}
                      style={{
                        textDecoration: 'underline',
                        color: '#FF7A00',
                        fontSize: 22,
                        cursor: 'pointer',
                        fontStyle: 'bold',
                        fontWeight: '700',
                        backgroundColor: 'transparent',
                      }}
                    >
                      영상 불러오기
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              margin: '0 auto',
              marginTop: '21px',
              display: 'flex',
              alignItems: 'center',
              width: '845px',
            }}
          >
            <a
              href="https://youtu.be/Ixbhvgy1a0Q?si=3Fi5iyKE1jnI6jzW"
              target="_blank"
              rel="noreferrer"
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Inform />
              <span
                style={{
                  color: '#FF7A00',
                  fontSize: '14px',
                  fontWeight: '400px',
                  lineHeight: 'normal',
                  marginLeft: '6px',
                  verticalAlign: 'text-top',
                }}
              >
                콘텐츠 제작팁이 궁금하신가요 ?
              </span>
            </a>
          </div>
          {video && (
            <button
              style={{
                marginRight: '20px',
                display: 'flex',
                height: 40,
                borderRadius: 20,
                position: 'absolute',
                bottom: 20,
                right: 120,
                backgroundColor: '#CCCCCC',
                fontSize: 20,
                borderWidth: 0,
                cursor: 'pointer',
                color: '#4D4D4D',
                fontWeight: 700,
                padding: '10px 30px',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              onClick={() => {
                history.push({
                  pathname: '/mypage/contents-making/contents-modal/video-list',
                  state: {
                    ...location.state,
                    isModify: location.state?.isModify ?? false,
                  },
                });
              }}
            >
              영상 변경하기
            </button>
          )}
          <button
            style={
              video
                ? {
                    display: 'flex',
                    height: 40,
                    borderRadius: 20,
                    position: 'absolute',
                    bottom: 20,
                    right: 0,
                    backgroundColor: '#FFB600',
                    fontSize: 20,
                    borderWidth: 0,
                    cursor: 'pointer',
                    fontWeight: 700,
                    padding: '10px 30px',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#FFF',
                  }
                : {
                    display: 'flex',
                    width: 100,
                    height: 40,
                    position: 'absolute',
                    bottom: 20,
                    right: 0,
                    borderRadius: 20,
                    backgroundColor: '#CCCCCC',
                    color: '#4D4D4D',
                    fontSize: 20,
                    borderWidth: 0,
                    cursor: 'pointer',
                    fontWeight: 700,
                    padding: '10px 30px',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }
            }
            onClick={() => {
              video
                ? history.push({
                    pathname:
                      '/mypage/contents-making/contents-modal/image-regist',
                    state: {
                      ...location.state,
                      video,
                      contentNo,
                      isModify: false,
                    },
                  })
                : alert('영상을 선택해주세요');
            }}
          >
            다음
          </button>
        </div>
      </div>
    </Router>
  );
}

export default ContentRegist;
